module.exports = __webpack_public_path__ + "static/img/right_up.ae46514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/right_up.png?1
// module id = 1zhP
// module chunks = 1